module.exports = __webpack_public_path__ + "img/sixpackcarrier03.21495cf9.jpg";